import store from '@/store'
import { browser as br } from '@/helpers'

const browser = br()

export default function widgetFunctions() {
  const currentBreakPoint = store.getters['app/currentBreakPoint']

  // Remove widget in the active board
  function addWidget(data) {
    // Open one Widget by board only for mobil
    if (currentBreakPoint === 'xs' || currentBreakPoint === 'sm') {
      store.commit('boards/ADD_BOARD')
      store.commit('boards/SELECT_BOARD', store.state.boards.boards.length - 1)
    }

    let boardIndex
    let boardId
    if (data.board) {
      boardIndex = data.boardIndex
      boardId = data.board
    } else {
      boardIndex = store.state.boards.boards.findIndex(
        board => board.isActive,
      )
      boardId = store.state.boards.boards.find(objeto => objeto.isActive === true)?.id
    }

    const promise = new Promise(resolve => {
      store.commit('boards/ADD_WIDGET', {
        ...data,
        boardIndex,
        boardId,
      })
      resolve()
    })

    promise.then(() => {
      const { widgets } = store.state.boards.boards.find(board => board.id === boardId)
      const widgetsLength = widgets.length
      const lastWidget = widgets[widgetsLength - 1]
      const element = document.getElementById(
        `${lastWidget.type}-${lastWidget.uniqueId}`,
      )

      if (browser === 'Firefox') {
        const rootEle = document.documentElement
        // timeout to crhome browser, chrome tries to scroll before widget is added
        setTimeout(() => {
          const widgetRect = element.getBoundingClientRect()
          const bodyHeight = document.body.getBoundingClientRect().top
          rootEle.scrollTo({
            left: 0,
            top: widgetRect.top - bodyHeight - widgetRect.height / 2,
            behavior: 'smooth',
          })
        }, 100)
      } else {
        try {
          element.addEventListener(
            'transitionend',
            ({ propertyName, target }) => {
              const rootEle = document.documentElement
              const scrolled = element.querySelector(
                'input[name="data-scrolled"]',
              )
              if (scrolled.value) return
              if (
                propertyName === 'transform'
                && target === element
                && rootEle.style.cursor !== 'move'
              ) {
                scrolled.value = 'scrolled'
                const values = element.style.transform.split(/\w+\(|\);?/)
                const transformY = values[1]
                  .split(',')[1]
                  .replace('px', '')
                  .replace(' ', '')
                rootEle.scrollTo({
                  left: 0,
                  top: transformY,
                })
              }
            },
          )
        } catch {
          //
        }
      }
    })
  }

  // Remove widget in the active board
  function removeWidget(widgetIndex) {
    const boardIndex = store.state.boards.boards.findIndex(
      board => board.isActive,
    )
    store.commit('boards/REMOVE_WIDGET', {
      boardIndex,
      widgetIndex,
    })

    // Remove board in mobile version
    if (currentBreakPoint === 'xs' || currentBreakPoint === 'sm') {
      store.commit('boards/REMOVE_BOARD', boardIndex)
    }
  }

  function restoreWidgets(widget) {
    addWidget({
      ...widget,
      boardIndex: widget.boardIndex,
      board: widget.board,
      focus: false,
      height: widget.h,
      width: widget.baseW ?? widget.w,
    })
  }

  function restoreBoards() {
    const boards = JSON.parse(sessionStorage.getItem('storedBoards')) ?? []
    boards.forEach(board => {
      if (board.widgets !== undefined && board.widgets.length !== 0) {
        store.commit('boards/ADD_BOARD', board.id)
        const { widgets } = board
        widgets
          .filter(widget => widget && typeof widget === 'object')
          .forEach(widget => {
            restoreWidgets(widget)
          })
      }
    })
  }

  const elementsIds = () => {
    const elements = []
    const allElements = document.querySelectorAll('*')
    allElements.forEach(e => {
      if (e.id && e.id.startsWith('id-')) {
        elements.push(e.id)
      }
    })
    return elements
  }

  const scrollElement = e => {
    e.scrollIntoView({
      behavior: 'smooth',
    })
  }

  const animation = e => {
    e.classList.add('border-primary')
    e.classList.add('rounded')
    setTimeout(() => {
      e.classList.remove('border-primary')
      e.classList.remove('rounded')
    }, 1000)
  }

  const verifyWidget = (idValue, widgetParams) => {
    const elements = elementsIds()
    if (elements.includes(`id-${idValue}`)) {
      const el = document.getElementById(`id-${idValue}`)
      scrollElement(el)
      setTimeout(() => {
        animation(el)
      }, 500)
    } else {
      addWidget({
        ...widgetParams,
      })
    }
  }

  // Returns price with the important decimals to be displayed bigger
  function scisaPrice(price, template = 'XX.##xxxx') {
    price = price.toString()
    const [, templateDecimals] = template.split('.')
    let [, decimals] = price.split('.')
    const [number] = price.split('.')
    if (!decimals) {
      decimals = '000000'
    }
    const formattedNumber = number.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    const formatedDecimals = []
    for (let i = 0; i < templateDecimals.length; i += 1) {
      if (templateDecimals[i] === '#') formatedDecimals.push({ number: decimals[i], isImportant: true })
      else formatedDecimals.push({ number: decimals[i], isImportant: false })
    }
    // returns two args, first one is the natural number, second one is an array of objects with each decimal of the template
    return { formattedNumber, formatedDecimals }
  }

  return {
    addWidget,
    removeWidget,
    restoreWidgets,
    restoreBoards,

    scisaPrice,

    elementsIds,
    scrollElement,
    animation,
    verifyWidget,
  }
}
